export const defaultRulePlugins = [];
//# sourceMappingURL=default.js.map